import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { GameConstants } from "../../../GameConstants";
import { BoardContainer } from "../BoardContainer";
import { GameVars } from "../../../GameVars";
import { Card } from "../cards/Card";
import { PlayerCard } from "../cards/PlayerCard";

export class Tableau extends Phaser.GameObjects.Container {

    public cards: Card[];
    public positionRects: Phaser.Geom.Rectangle[];
    public cardsContainer: Phaser.GameObjects.Container;

    protected highlightFrames: Phaser.GameObjects.Image[];
    

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.cards = [];

        this.cardsContainer = new Phaser.GameObjects.Container(this.scene);
        this.add(this.cardsContainer);

        this.addMarkers();
    }

    protected addMarkers(): void {

        this.highlightFrames = [];

        for (let i = 0; i < 4; i++) {
                
            const p = this.getCardPosition(i);
                
            this.highlightFrames[i] = new Phaser.GameObjects.Image(this.scene, p.x, p.y, "texture_atlas_1", "position_highlight");
            this.highlightFrames[i].angle = p.angle;
            this.highlightFrames[i].visible = false;
            this.add(this.highlightFrames[i]);
        }

        this.positionRects = [];

        for (let i = 0; i < 4; i++) {

            const p = this.getCardPosition(i);

            const tmpRect = new Phaser.Geom.Rectangle(p.x - BoardContainer.CARD_WIDTH / 2, p.y - BoardContainer.CARD_HEIGHT / 2, BoardContainer.CARD_WIDTH, BoardContainer.CARD_HEIGHT);
            this.positionRects[i] = tmpRect;
        }

        if (GameConstants.DEBUG) {
                
            this.positionRects.forEach((rect: Phaser.Geom.Rectangle) => {
                const tmpGraphics = this.scene.add.graphics();
                tmpGraphics.lineStyle(2, 0xFFFFFF, 1);  
                tmpGraphics.strokeRectShape(rect);
                this.add(tmpGraphics);
            });
        }
    } 

    public onActionProcessed(): void {

        const removedCards = GameVars.cardCrawlEngine.getState().uiData.removedCards;
        
        this.cards.forEach((card: Card) => {

            const removedCardData = removedCards.find(c => c.id === card.id);

            if (removedCardData) {
                card.removeFromScene(removedCardData, false);
            } else {  
                card.removeFromScene(null, true);
            }
        });

        this.cards = [];

        const state = GameVars.cardCrawlEngine.getState();
        
        let cards: CardCrawl.CardData[] = [];

        if (this.type === CardCrawl.TableauType.UPPER) {
            cards = state.upperTableau;
        } else {
            cards = state.lowerTableau;
        }  

        for (let i = 0; i < cards.length; i++) {

            const cardData = cards[i];

            if (cardData !== null) {

                const p = this.getCardPosition(i);

                let card: Card;

                if (cardData.type === CardCrawl.CardType.PLAYER) {
                    card = new PlayerCard(this.scene, p, cardData);
                } else {
                    card = new Card(this.scene, p, cardData);
                }

                if (card) {
                    this.cardsContainer.addAt(card, 0);
                    this.cards[i] = card;
                }  
            }
        }
    }  

    public showAllowedMoves(card: CardCrawl.CardData): void {
        //
    }

    public hideAllowedMoves(): void {

        if (!this.scene) {
            return;
        }
        
        this.highlightFrames.forEach((frame: Phaser.GameObjects.Image) => {
            frame.visible = false;
            this.scene.tweens.killTweensOf(frame);
        });
    }
    
    public getOverlappingIndex(x: number, y: number): number {

        for (let i = 0; i < this.positionRects.length; i++) {

            if (this.positionRects[i].contains(x, y)) {
                return i;
            }
        }

        return null;
    }   

    public getCardPosition(index: number): {x: number, y: number, angle: number} {

        return {x: 0, y: 0, angle: 0};
    }
}
